<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="申请单号"><el-input v-model="query.ecrCode" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item label="标题"><el-input v-model="query.title" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item label="审核">
        <el-select v-model="query.approveStatus" clearable size="small" style="width:100px">
          <el-option label="未审" value="0" /><el-option label="已审" value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('plm:plmEcr:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button v-if="isAuth('plm:plmEcr:save')" type="primary" size="small" @click="open()">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="pageList" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="ecrCode" label="申请单号" min-width="130" header-align="center" align="left">
        <template slot-scope="scope">
          <a v-if="isAuth('plm:plmEcr:info')" class="code-link" @click="open(scope.row, true)">{{ scope.row.ecrCode }}</a>
          <span v-else>{{ scope.row.ecrCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" min-width="140" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="materialCode" label="物料" min-width="110" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="changeLevel" label="级别" width="80" header-align="center" align="center">
        <template slot-scope="scope">{{ scope.row.changeLevel === 'minor' ? '一般' : '重大' }}</template>
      </el-table-column>
      <el-table-column prop="approveStatus" label="审核" width="80" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.approveStatus === '2' ? 'success' : 'info'" size="mini">{{ scope.row.approveStatus === '2' ? '已审' : '未审' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" header-align="center" align="center">
        <template slot-scope="scope">
          <el-button v-if="isAuth('plm:plmEcr:approve') && scope.row.approveStatus !== '2'" type="text" size="small" @click="approve(scope.row)">审核</el-button>
          <el-button v-if="isAuth('plm:plmEcr:unapprove') && scope.row.approveStatus === '2' && !scope.row.ecnId" type="text" size="small" @click="unapprove(scope.row)">弃审</el-button>
          <el-button v-if="isAuth('plm:plmEcn:save') && scope.row.approveStatus === '2' && !scope.row.ecnId" type="text" size="small" @click="toEcn(scope.row)">转ECN</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="s => { pageSize = s; pageIndex = 1 }" @current-change="p => { pageIndex = p }" />

    <el-dialog :visible.sync="visible" width="min(640px, calc(100vw - 24px))" :close-on-click-modal="false">
      <template slot="title">
        <div class="doc-dialog-header">
          <span class="doc-dialog-title">{{ dialogTitle }}</span>
          <div v-if="readonly && form.ecrId" class="doc-dialog-actions">
            <el-button-group>
              <el-button v-if="isAuth('plm:plmEcr:update') || isAuth('plm:plmEcr:save')" type="primary" size="small" :disabled="form.approveStatus === '2'" @click="editFromView">修改</el-button>
              <el-button v-if="isAuth('plm:plmEcr:delete') || isAuth('plm:plmEcr:save')" type="danger" size="small" :disabled="form.approveStatus === '2'" @click="deleteFromView">删除</el-button>
            </el-button-group>
          </div>
        </div>
      </template>
      <el-form ref="dataForm" v-loading="infoLoading" :model="form" :rules="readonly ? {} : rules" label-width="100px" :disabled="readonly || infoLoading">
        <el-form-item label="申请单号" prop="ecrCode"><el-input v-model="form.ecrCode" :disabled="!!form.ecrId" /></el-form-item>
        <el-form-item label="标题" prop="title"><el-input v-model="form.title" /></el-form-item>
        <el-form-item label="关联物料">
          <el-input v-model="form.materialCode" readonly placeholder="点击选择">
            <el-button v-if="!readonly" slot="append" @click="materialSelectorVisible = true">选择</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="变更级别">
          <el-select v-model="form.changeLevel" style="width:100%">
            <el-option label="重大" value="major" /><el-option label="一般" value="minor" />
          </el-select>
        </el-form-item>
        <el-form-item label="变更原因"><el-input v-model="form.changeReason" type="textarea" :rows="3" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">关闭</el-button>
        <el-button v-if="!readonly" type="primary" :disabled="infoLoading" @click="save">确定</el-button>
      </span>
    </el-dialog>
    <material-selector :visible.sync="materialSelectorVisible" :multiple="false" @select="onMaterialSelect" />
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import MaterialSelector from '../../components/MaterialSelector.vue'

export default {
  name: 'PlmEcr',
  components: { MaterialSelector },
  data() {
    return {
      query: { ecrCode: '', title: '', approveStatus: '' },
      list: [], pageIndex: 1, pageSize: 10, loading: false, visible: false, readonly: false, infoLoading: false, infoRequestId: 0,
      materialSelectorVisible: false, permCodes: [], form: {},
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' },
      rules: {
        ecrCode: [{ required: true, message: '申请单号不能为空', trigger: 'blur' }],
        title: [{ required: true, message: '标题不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看变更申请'
      return this.form.ecrId ? '修改变更申请' : '新增变更申请'
    },
    filtered() {
      return this.list.filter(row => this.has(row.ecrCode, this.query.ecrCode) && this.has(row.title, this.query.title) && (!this.query.approveStatus || row.approveStatus === this.query.approveStatus))
    },
    total() { return this.filtered.length },
    pageList() { return this.filtered.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize) }
  },
  created() { this.loadPerms(); this.load() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    has(value, keyword) {
      const text = String(keyword || '').trim().toLowerCase()
      if (!text) return true
      return String(value || '').toLowerCase().indexOf(text) >= 0
    },
    search() { this.pageIndex = 1; this.load() },
    load() {
      this.loading = true
      request.get('/plm/ecr/list').then(res => { this.list = res.data || [] }).catch(() => { this.list = [] }).finally(() => { this.loading = false })
    },
    onMaterialSelect(row) {
      this.form.materialId = row.materialId
      this.form.materialCode = row.materialCode
      this.form.materialName = row.materialName
      this.materialSelectorVisible = false
    },
    editFromView() {
      if (String(this.form.approveStatus) === '2') {
        this.$message.warning('已审核的单据不可修改，请先弃审')
        return
      }
      this.readonly = false
    },
    deleteFromView() {
      if (String(this.form.approveStatus) === '2') {
        this.$message.warning('已审核的变更申请不可删除，请先弃审')
        return
      }
      this.$confirm('确定删除该变更申请?', '提示', { type: 'warning' }).then(() => {
        request.post('/plm/ecr/delete', { id: this.form.ecrId }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    },
    open(row, readonly) {
      this.readonly = !!readonly
      const requestId = ++this.infoRequestId
      const blank = () => ({
        ecrId: '', ecrCode: '', title: '', changeReason: '', remark: '', approveStatus: '0',
        materialId: '', materialCode: '', materialName: '', changeLevel: 'major'
      })
      if (!row || !row.ecrId) {
        this.infoLoading = false
        this.form = blank()
        this.visible = true
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
        return
      }
      this.form = Object.assign(blank(), row)
      this.infoLoading = true
      this.visible = true
      request.get('/plm/ecr/info', { params: { id: row.ecrId } }).then(res => {
        if (requestId !== this.infoRequestId || !this.visible || this.form.ecrId !== row.ecrId) return
        this.form = Object.assign(blank(), res.data || row)
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      }).catch(() => {
        if (requestId !== this.infoRequestId || !this.visible || this.form.ecrId !== row.ecrId) return
        this.visible = false
        this.$message.error('变更申请详情加载失败，请重试')
      }).finally(() => { if (requestId === this.infoRequestId) this.infoLoading = false })
    },
    save() {
      if (this.infoLoading) return
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        request.post('/plm/ecr/save', {
          ecrId: this.form.ecrId, ecrCode: this.form.ecrCode, title: this.form.title,
          changeReason: this.form.changeReason, remark: this.form.remark,
          materialId: this.form.materialId, changeLevel: this.form.changeLevel
        }).then(() => { this.$message.success('保存成功'); this.visible = false; this.load() }).catch(() => {})
      })
    },
    approve(row) {
      request.post('/plm/ecr/approve', { id: row.ecrId }).then(() => { this.$message.success('审核成功'); this.load() }).catch(() => {})
    },
    unapprove(row) {
      request.post('/plm/ecr/unapprove', { id: row.ecrId }).then(() => { this.$message.success('弃审成功'); this.load() }).catch(() => {})
    },
    toEcn(row) {
      request.post('/plm/ecr/toEcn', { id: row.ecrId }).then(() => { this.$message.success('已生成 ECN，请到变更通知维护明细'); this.load() }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; }
</style>
